import {
    FETCH_SYSTEM_LIST_SUCCESS,
    FETCH_SYSTEM_LIST_ITEM_SUCCESS,

    SYSTEM_LIST_REQUEST_LOADING,
    SYSTEM_LIST_REQUEST_ERRORS
} from "api/menu/master-files/system-list/actions";

const initialState = {
    loading: false,
    errors: [],

    systems: [],
    systemsItem: [],
};

export default function(state = initialState, action) {
    switch (action.type) {
        case SYSTEM_LIST_REQUEST_LOADING:
            return {
                ...state,
                loading: true
            };
        case SYSTEM_LIST_REQUEST_ERRORS:
            return {
                ...state,
                loading: false,
                errors: action.payload
            };
        case FETCH_SYSTEM_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                systems: action.payload
            };
        case FETCH_SYSTEM_LIST_ITEM_SUCCESS:
            return {
                ...state,
                loading: false,
                systemsItem: action.payload
            };
        default:
            return state;
    }
}
